import axios from 'axios';

/**
 * Validates and retrieves a Gemini API key.
 * Prioritizes user's personal key, falls back to system keys.
 */
export const validateGeminiKey = async (email) => {
  try {
    const userKeyRes = await axios.get(`https://allinone-clone-7d5d795e98ce.herokuapp.com/api/user-gemini-key?email=${email}`);
    if (userKeyRes.data?.success && userKeyRes.data?.key) {
      return userKeyRes.data.key;
    }
  } catch (err) {
    // ignore user key error and fallback
  }

  try {
    const response = await axios.get(`https://allinone-clone-7d5d795e98ce.herokuapp.com/api/gemini-keys`);
    if (response.data?.success && response.data?.data) {
      const keys = response.data.data.map((keyObj) => keyObj.key);
      if (keys.length > 0) {
        return keys[Math.floor(Math.random() * keys.length)];
      }
    }
  } catch (err) {
    console.error("Error fetching system keys", err);
  }
  
  throw new Error("No API keys available. Please set your Gemini API key on the homepage or contact the administrator.");
};

/**
 * Deducts credit from a user. Can also be used to refund if amount is negative.
 */
export const deductUserCredit = async (email, amount, toolPath = "") => {
  if (amount < 0) {
      // It's a refund
      try {
        const refundRes = await axios.post(`https://allinone-clone-7d5d795e98ce.herokuapp.com/api/refund-credit`, {
            userEmail: email,
            amount: Math.abs(amount)
        });
        if (!refundRes.data.success) {
            throw new Error("Credit refund failed");
        }
        return refundRes.data;
      } catch (err) {
          throw err;
      }
  } else {
      // It's a deduction
      try {
        const deductRes = await axios.post(
          `https://allinone-clone-7d5d795e98ce.herokuapp.com/api/deduct-credit`,
          {
            userEmail: email,
            amount: amount,
            toolPath: toolPath
          }
        );
        if (!deductRes.data.success) {
          throw new Error("Credit deduction failed");
        }
        return deductRes.data;
      } catch (error) {
        throw error;
      }
  }
};
